<template>
  <div>
    <div class="doctorPage doctorSeach managerPlan">
      <div class="selectSearch">
        <el-tabs class="fileUpTabs" v-model="categoryId" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in categoryList" :key="index" :label="item.name" :name="item.id">{{item.name}}</el-tab-pane>
        </el-tabs>
        <el-form
          ref="form"
          :model="listParameter"
          class="qcFrom searchConditions"
          :inline="true"
        >
          <el-form-item label="文件名称">
            <el-input
              v-model="listParameter.name"
              class="name"
              placeholder="请输入文件名称"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" v-if="!isliststandard">
            <el-select
              v-model="listParameter.status"
              placeholder="请选择"
              size="mini"
              style="width: 160px"
            >
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="已共享" :value="1"></el-option>
              <el-option label="未共享" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分享人" v-if="isliststandard">
            <el-input
              v-model="listParameter.UserName"
              class="UserName"
              placeholder="请输入分享人"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search" round>查询</el-button>
            <el-button type="primary" class="resetBtn" @click="resetForm()">重置</el-button>
          </el-form-item>
          <a href="javascript:;" v-if="!isliststandard" class="addbtn" @click="uploadFile">上传文件</a>
        </el-form>
      </div>
      <div class="centerHome">
        <div class="ccHomel">
          <div class="compentTable">
            <el-table class="qcTable" :data="list" v-loading="loading">
              <el-table-column
                type="index"
                label="序号"
                width="80"
              ></el-table-column>
              <el-table-column prop="Name" label="文件名称"></el-table-column>
              <el-table-column prop="Size" label="文件大小">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.Size < 1024
                      ? scope.row.Size + "字节"
                      : Math.round(scope.row.Size / 1024) + "KB"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Status" label="状态" v-if="!isliststandard"></el-table-column>
              <el-table-column prop="UserName" label="上传人" ></el-table-column>
              <el-table-column prop="CategoryName" label="分类"></el-table-column>
             <el-table-column
                prop="CreateTime"
                label="上传时间"
              ></el-table-column>
              <el-table-column
                prop=""
                label="操作"
                min-width="80"
                fixed="right"
              >
                <template slot-scope="scope">
                  <span
                    class="table-task-btn detail"
                    @click="viewClick(scope.row)"
                    >查看</span
                  >
                  <span class="table-task-btn detail" v-if="!isliststandard" @click="setUp(scope.row)"
                    >设置</span
                  >
                  <span
                    class="table-task-btn detail"
                    @click="download(scope.row)"
                    >下载</span
                  >
                  <span
                    class="table-task-btn detail"
                    v-if="!isliststandard&&scope.row.Status == '未共享'"
                    @click="deleteClick(scope.row)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination
                class="pageAll"
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="listParameter.pageSize"
                :current-page="listParameter.pageIndex"
                @current-change="currentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        :title="title"
        width="90%"
        height="80%"
        @closed="onPreviewDialogClosed"
      >
        <!-- 优先经 DownFile 拉成 Blob 预览（同源，可绕过 OBS 的 attachment 与跨域）；直链 http(s) 时见下方说明 -->
        <div
          v-if="filePreviewUrl || pdfOpening"
          v-loading="pdfOpening"
          class="pdf-preview-dialog-body"
        >
          <el-alert
            v-if="filePreviewUrl && isObsStyleDirectPdfUrl"
            type="warning"
            :closable="false"
            show-icon
            title="当前为对象存储直链：新窗口若直接下载而非打开，通常是响应头 Content-Disposition: attachment（或类型非 application/pdf）。请在 OBS 将对象元数据改为 ContentDisposition:inline，或让后端上传/回源时带上 inline。"
            class="pdf-obs-hint"
          />
          <div class="pdf-mode-bar">
            <span class="pdf-mode-label">预览方式</span>
            <el-radio-group v-model="pdfPreviewMode" size="mini" @change="onPdfPreviewModeChange">
              <el-radio-button label="native">传统模式</el-radio-button>
              <el-radio-button label="pdfjs">画布模式</el-radio-button>
            </el-radio-group>
          </div>
          <pdfView
            v-if="pdfPreviewMode === 'pdfjs'"
            :key="'pdfjs-' + filePreviewUrl"
            :url="filePreviewUrl"
            @load-error="onPdfJsLoadError"
          />
          <iframe
            v-else
            class="pdf-native-frame"
            :src="filePreviewUrl"
            title="PDF 预览"
          ></iframe>
        </div>
      </el-dialog>
      <el-dialog
        title="设置"
        :visible.sync="dialog"
        width="50%"
        center
        class="scrollbar userListParameter dialogFrom"
      >
        <el-form
          label-width="100px"
          class="qcFrom dialogScoped"
          ref="setuserListParameter"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="选择分类：">
                <el-col>
                  <el-radio-group v-model="category">
                    <el-radio :label="1">技术扫描规范</el-radio>
                    <el-radio :label="2">诊断报告要求</el-radio>
                    <el-radio :label="3">集团内诊断共识</el-radio>
                    <el-radio :label="4"> 影像共识</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
              <el-form-item label="文件共享：">
                <el-col>
                  <el-radio-group v-model="status">
                    <el-radio :label="1">共享</el-radio>
                    <el-radio :label="0">不共享</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer mart25" align="center">
          <el-button type="primary" @click="dialogClick(false)"
            >保 存</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="选择分类"
        :visible.sync="fileTypeVisible"
        width="70%"
        center
        class="scrollbar userListParameter dialogFrom"
      >
        <el-form
          label-width="100px"
          class="qcFrom dialogScoped"
          ref="setuserListParameter"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="选择分类：">
                <el-col>
                  <el-radio-group v-model="category">
                    <el-radio :label="1">技术扫描规范</el-radio>
                    <el-radio :label="2">诊断报告要求</el-radio>
                    <el-radio :label="3">集团内诊断共识</el-radio>
                    <el-radio :label="4"> 影像共识</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer mart25" align="center">
          <!-- <el-button type="primary" @click="fileTypeClick(false)"
            >确 定</el-button> -->
           <el-upload
            class="upload-demo"
            ref="upload"
            :action="fileUpload"
            :headers="{ 'Content-Type': 'application/octet-stream' }"
            :before-upload="beforeAvatarUpload"
            :on-success="onSuccess"
            :on-error="handleError"
            :raw="true"
            :multiple="false"
          >
            <el-button type="primary">上传文件</el-button>
          </el-upload>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import jsaxios from "axios";
import Api from "@/api/index.js";
import axios from "@/js/api";
import * as mammoth from "mammoth";
import * as XLSX from "xlsx";
// import pdfjsLib from 'pdfjs-dist';
// import pdfjsLib from "pdfjs-dist";
// import 'regenerator-runtime/runtime';
import pdfView from '@/components/pdfView/index.vue'
export default {
  data() {
    return {
      listParameter: {
        status: -1,
        name: "",
        pageIndex: 1,
        pageSize: 10
      },
      categoryId:'0',
      loading: false,
      list: [],
      dialog: false,
      status: 1,
      fileUpload: Api.api.manager.FileUpload,
      totalCount: 0,
      id: 0,
      dialogVisible: false,
      fileTypeVisible: false,
      url: "",
      fileContent: "",
      fileDocContent: "",
      title: "",
      sheetData: [],
      pdfDocument: null,
      pdfPageNum: 1,
      filePreviewUrl: '',
      /** pdfjs：PDF.js；native：iframe 原生查看器（跨域拉取失败时用） */
      pdfPreviewMode: 'native',
      /** 打开预览中（先尝试经 DownFile 拉 Blob） */
      pdfOpening: false,
      /** createObjectURL 生成的地址，关闭弹窗时必须 revoke */
      pdfBlobObjectUrl: '',
      category:1,
      categoryList:[{name:'全部',id:'0'},{name:'技术扫描规范',id:'1'},{name:'诊断报告要求',id:'2'},{name:'集团内诊断共识',id:'3'},{name:'影像共识',id:'4'}],
      isliststandard:false
    };
  },
  components: {
			pdfView
	},
  computed: {
    /** 直链且像对象存储地址时提示「attachment 导致下载」 */
    isObsStyleDirectPdfUrl() {
      const u = this.filePreviewUrl || '';
      if (!u || u.indexOf('blob:') === 0) return false;
      return /^https?:\/\//i.test(u);
    },
  },
  mounted() {
    this.getFileInfo();
  },
  methods: {
    resetForm(){
      this.listParameter.name = ''
      this.listParameter.status = -1
      this.listParameter.UserName = ''
      this.getFileInfo();
    },
    handleClick(tab, event){
      this.getFileInfo()
    },
    uploadFile(){
      this.fileTypeVisible = true
    },
    getFileInfo() {
      this.loading = true;
      this.listParameter.category = Number(this.categoryId)
      if (window.location.pathname.includes('liststandard')) {
        this.isliststandard = true;
        console.log(Api.api.manager.GetShareFile);
        axios
          .ajaxGet("get", Api.api.manager.GetShareFile, this.listParameter)
          .then((res) => {
            if (res.data.StatusCode == 200) {
              this.list = res.data.Result;
              this.totalCount = res.data.Total;
            } else {
              this.$message({
                type: "info",
                message: res.data.Msg,
              });
            }
            this.loading = false;
          });
      }else{
        axios
          .ajaxGet("get", Api.api.manager.getFileInfo, this.listParameter)
          .then((res) => {
            if (res.data.StatusCode == 200) {
              this.list = res.data.Result;
              this.totalCount = res.data.Total;
            } else {
              this.$message({
                type: "info",
                message: res.data.Msg,
              });
            }
            this.loading = false;
          });
      }
    },
    dialogClick(type) {
      this.dialog = type;
      axios
        .ajaxGet("put", Api.api.manager.UpdateFileStatusById, {
          Id: this.id,
          status: this.status,
          category: this.category
        })
        .then((res) => {
          if (res.data.StatusCode == 200) {
            this.getFileInfo();
          } else {
            this.$message({
              type: "info",
              message: res.data.Msg,
            });
          }
        });
    },
    handleUploadRemove(file, fileList) {
      this.proofImage = "";
    },
    beforeAvatarUpload(file) {
        var maxFileSize = 100 * 1024 * 1024;
        console.log(maxFileSize);
      	let fname = file.name.toUpperCase();
				if(fname.match("PPTX|PPT|XLSX|XLS|DOC|DOCX|TXT|JPG|PNG|JPEG|PDF") == null) {
					this.$message.error('非可上传格式!');
					return false;
				}
    		if (!maxFileSize) {
					this.$message.error('上传头像图片大小不能超过限制!');
				}
      const formData = new FormData();
      formData.append("file", file);
      axios
        .uploadPost("post", Api.api.manager.FileUpload+'?category='+this.category, formData, {
          "Content-Type": "multipart/form-data; boundary=" + file.uid,
        })
        .then((res) => {
          this.fileTypeVisible = false
          this.getFileInfo();
        });
      return false; 
      // 阻止自动上传
      //   const isLt2M = file.size / 1024 / 1024 < 1;
      //   let fname = file.name.toUpperCase();
      //   if (fname.match("JPG|PNG|JPEG") == null) {
      //     this.$message.error("上传图片需要JPG或者PNG格式!");
      //     return false;
      //   }
      //   if (!isLt2M) {
      //     this.$message.error("上传头像图片大小不能超过 1MB!");
      //   }
      //   return isLt2M;
    },
    onSuccess(response, file) {
      // 文件上传成功回调
      console.log("文件上传成功:", response);
    },
    handleError(err, file) {
      // 文件上传失败回调
      console.error("文件上传失败:", err);
    },
    search() {
      this.getFileInfo();
    },
    currentChange(val) {
      this.listParameter.pageIndex = val;
      this.getFileInfo();
    },
    setUp(row) {
      this.dialog = true;
      this.id = row.Id;
      this.status = row.Status == "未共享" ? 0 : 1;
      this.category = row.Category
    },
    viewClick(row) {
      const path = row.Path || '';
      const isPdf = /\.pdf(\?|$)/i.test(path) || /\.pdf(\?|$)/i.test(row.Name || '');
      if (!isPdf) {
        // 非 PDF 仍走浏览器直链（Office 等需本地下载或专用客户端）
        if (path) window.open(path, '_blank');
        else this.$message.warning('文件地址无效');
        return;
      }
      this.title = row.Name;
      this.pdfPreviewMode = 'native';
      this.revokePdfBlob();
      this.filePreviewUrl = '';
      this.dialogVisible = true;
      this.openPdfPreview(row, path);
    },
    /**
     * 优先用同源 DownFile 拉二进制生成 Blob URL，避免 OBS 上 attachment 导致只能下载、以及 PDF.js 跨域。
     * 失败再退回 row.Path 直链。
     */
    async openPdfPreview(row, path) {
      this.pdfOpening = true;
      const http = typeof window !== 'undefined' && window.axios ? window.axios : null;
      let ok = false;
      if (http && row.Id != null && row.Id !== '') {
        try {
          const url = `${axios.herf}${Api.api.manager.DownFile}?id=${encodeURIComponent(row.Id)}`;
          const res = await http.get(url, { responseType: 'blob' });
          const blob = res.data;
          if (!(blob instanceof Blob) || blob.size === 0) {
            throw new Error('空文件');
          }
          const magic = await blob.slice(0, 5).text();
          if (!magic.startsWith('%PDF')) {
            if (blob.size < 8192) {
              const txt = await blob.text();
              if (txt.trim().startsWith('{')) {
                const j = JSON.parse(txt);
                if (j.StatusCode != null && Number(j.StatusCode) !== 200) {
                  throw new Error(j.Msg || '接口返回错误');
                }
              }
              throw new Error('响应体不是 PDF');
            }
          }
          const pdfBlob =
            blob.type === 'application/pdf'
              ? blob
              : new Blob([blob], { type: 'application/pdf' });
          this.revokePdfBlob();
          this.pdfBlobObjectUrl = URL.createObjectURL(pdfBlob);
          this.$nextTick(() => {
            this.filePreviewUrl = this.pdfBlobObjectUrl;
          });
          ok = true;
        } catch (e) {
          console.warn('经 DownFile 生成 PDF 预览失败，将使用存储直链:', e);
        }
      }
      if (!ok) {
        this.$nextTick(() => {
          this.filePreviewUrl = path;
        });
      }
      this.pdfOpening = false;
    },
    revokePdfBlob() {
      if (this.pdfBlobObjectUrl) {
        URL.revokeObjectURL(this.pdfBlobObjectUrl);
        this.pdfBlobObjectUrl = '';
      }
    },
    onPdfJsLoadError() {
      if (this.pdfPreviewMode !== 'pdfjs') return;
      this.pdfPreviewMode = 'native';
      this.$message.info('画布预览因跨域等原因失败，已切换为浏览器内嵌预览');
    },
    onPdfPreviewModeChange(mode) {
      // 从 iframe 切回 PDF.js 时需强制重挂子组件
      if (mode !== 'pdfjs' || !this.filePreviewUrl) return;
      const u = this.filePreviewUrl;
      this.filePreviewUrl = '';
      this.$nextTick(() => {
        this.filePreviewUrl = u;
      });
    },
    onPreviewDialogClosed() {
      this.filePreviewUrl = '';
      this.pdfPreviewMode = 'pdfjs';
      this.revokePdfBlob();
    },
    download(row) {
      window.open(
        axios.exportExcel(Api.api.manager.DownFile) + "?id=" + row.Id
      );
    },
    deleteClick(row) {
      this.$confirm(` 是否确定删除?<br>文件名称：${row.Name}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
      })
        .then((res) => {
          axios
            .ajaxPost("post", Api.api.manager.DeleteFileById, { Id: row.Id })
            .then((res) => {
              if (res.data.StatusCode == 200) {
                this.getFileInfo();
                this.$message.success("删除成功");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss">
  .fileUpTabs .el-tabs__nav{
  padding-bottom: 10px;
}
.fileUpTabs .el-tabs__nav-wrap::after{
  background-color: #4E5262;
  height: 1px;
}
.fileUpTabs .el-tabs__item.is-active{
  color: #248AFD;
}
.fileUpTabs .el-tabs__active-bar{
  background-color: #248AFD;
}
.fileUpTabs .el-tabs__item{
  // @include text-color(fzColor);
  color: #C4C4C4;
  font-weight: 400;
}
.fileUpTabs .el-tabs__content{
  display: none;
}
</style>
<style lang="scss" scoped="scoped">
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";
.table-task-btn {
  width: 25%;
}
.text-container {
  white-space: pre-wrap;
}
.el-dialog__body {
  // color: #fff;
  @include text-color(fzColor);
  max-height: 700px;
}
.sheetData h2 {
  margin: 10px 0;
  font-size: 14px;
}
.sheetData table {
  border: 1px solid #fff;
}

.sheetData {
  border-collapse: collapse;
  width: 100%;
}

.sheetData th,
.sheetData td {
  border-right: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.sheetData tr {
  border: 1px solid #ddd;
}
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
table {
  width: 100%;
  margin: auto;
}
.pdf-container {
  width: 100%;
}
.el-button-group{
    left: 50% !important;
}
.el-dialog .el-form-item__label{
  font-size: 15px;
}
.managerPlan .selectSearch{
  display: block;
}
.managerPlan .selectSearch .addbtn{
  right: 18px;
  top: 73%;
}
.pdf-preview-dialog-body {
  max-height: 75vh;
  overflow: auto;
}
.pdf-obs-hint {
  margin-bottom: 12px;
}
.pdf-mode-bar {
  margin-bottom: 12px;
}
.pdf-mode-label {
  margin-right: 10px;
  font-size: 13px;
  vertical-align: middle;
}
.pdf-native-frame {
  width: 100%;
  height: 75vh;
  border: 0;
  display: block;
}

</style>